(() => {
  const colorName = /^(colou?r|garment colou?r)$/i;
  const sizeName = /^size$/i;
  const matches = (variant, values) => variant.options.every((value, index) => !values[index] || value === values[index]);
  const selectValue = (field, value) => {
    field.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === value; });
  };

  function initProduct(section) {
    if (section.dataset.studioReady) return;
    let data;
    try {
      data = JSON.parse(section.querySelector('[data-studio-product-data]').textContent);
    } catch {
      return;
    }
    if (!Array.isArray(data.variants) || !data.variants.length) return;
    const form = section.querySelector('.studio-product-form');
    const variantSelect = section.querySelector('[data-studio-variant]');
    const fields = [...section.querySelectorAll('[data-studio-option-index]')];
    const media = [...section.querySelectorAll('[data-studio-media]')];
    const thumbs = [...section.querySelectorAll('[data-studio-show-media]')];
    const button = section.querySelector('[data-studio-add]');
    const status = section.querySelector('[data-studio-product-status]');
    const quantity = form.querySelector('[name="quantity"]');
    const colorIndex = fields.findIndex(field => colorName.test(field.dataset.optionName));
    const sizeIndex = fields.findIndex(field => sizeName.test(field.dataset.optionName));
    let currentColor;
    let currentMedia;
    let currentVariant;

    const values = () => fields.map(field => field.querySelector('input:checked')?.value || null);

    function showMedia(id, animate = false) {
      const target = media.find(item => item.dataset.studioMedia === String(id));
      if (!target) return;
      media.forEach(item => {
        item.hidden = item !== target;
        if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.studioShowMedia === String(id))));
      if (animate && currentMedia !== String(id) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.animate([{ opacity: 0, transform: 'translateY(7px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, easing: 'ease-out' });
      }
      currentMedia = String(id);
    }

    function updateGallery(selected, variant, initial) {
      const color = colorIndex < 0 ? null : selected[colorIndex];
      const colorMedia = color ? media.filter(item => (item.dataset.mediaAlt || '').includes(` — ${color} — `)) : [];
      const colorIds = new Set(colorMedia.map(item => item.dataset.studioMedia));
      thumbs.forEach(thumb => { thumb.hidden = colorMedia.length > 0 && !colorIds.has(thumb.dataset.studioShowMedia); });
      if (initial && !data.selectedId) {
        showMedia(data.featuredMediaId || media[0]?.dataset.studioMedia);
      } else if (initial || color !== currentColor || !currentMedia) {
        const back = colorMedia.find(item => / — Back$/i.test(item.dataset.mediaAlt || ''));
        const chosen = back?.dataset.studioMedia || (colorIds.has(String(variant?.mediaId)) ? variant.mediaId : null) || colorMedia[0]?.dataset.studioMedia || variant?.mediaId || data.featuredMediaId;
        showMedia(chosen, !initial);
      }
      currentColor = color;
    }

    function sync(initial = false) {
      const selected = values();
      const complete = selected.every(Boolean);
      const variant = complete ? data.variants.find(item => matches(item, selected)) : null;
      currentVariant = variant;
      variantSelect.value = variant ? String(variant.id) : '';
      fields.forEach((field, index) => {
        field.querySelector('[data-studio-option-label]').textContent = selected[index] || '';
        field.querySelectorAll('input[type="radio"]').forEach(input => {
          const candidateValues = selected.slice();
          candidateValues[index] = input.value;
          const available = data.variants.some(item => item.available && matches(item, candidateValues));
          input.closest('.studio-option-choice').classList.toggle('is-unavailable', !available);
          input.setAttribute('aria-label', available ? input.value : `${input.value} — ${data.labels.soldOut}`);
        });
      });
      const displayVariant = variant || data.variants.find(item => item.available && matches(item, selected)) || data.variants.find(item => matches(item, selected));
      if (displayVariant) {
        section.querySelector('[data-studio-price]').textContent = displayVariant.price;
        const comparePrice = section.querySelector('[data-studio-compare-price]');
        comparePrice.hidden = !displayVariant.comparePrice;
        comparePrice.textContent = displayVariant.comparePrice || '';
      }
      button.disabled = !(complete && variant?.available);
      button.textContent = !complete ? (sizeIndex >= 0 && !selected[sizeIndex] ? data.labels.size : data.labels.choose) : !variant ? data.labels.unavailable : variant.available ? data.labels.add : data.labels.soldOut;
      status.textContent = complete && !variant ? data.labels.unavailableMessage : '';
      if (variant) {
        const min = Number(variant.quantityMin) || 1;
        const step = Number(variant.quantityStep) || 1;
        const max = Number(variant.quantityMax) || null;
        quantity.min = String(min);
        quantity.step = String(step);
        if (max) quantity.max = String(max); else quantity.removeAttribute('max');
        let next = Math.max(min, Number(quantity.value) || min);
        next = min + Math.ceil((next - min) / step) * step;
        quantity.value = String(max ? Math.min(next, max) : next);
      }
      updateGallery(selected, displayVariant, initial);
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', String(variant.id)); else url.searchParams.delete('variant');
      if (url.href !== window.location.href) window.history.replaceState({}, '', url);
    }

    const selectedVariant = data.variants.find(variant => String(variant.id) === String(data.selectedId));
    if (selectedVariant) {
      fields.forEach((field, index) => selectValue(field, selectedVariant.options[index]));
    } else {
      let featuredColor;
      if (colorIndex >= 0) {
        featuredColor = [...fields[colorIndex].querySelectorAll('input')].find(input => (data.featuredMediaAlt || '').includes(` — ${input.value} — `))?.value;
      }
      const featuredVariant = data.variants.find(variant => featuredColor && variant.options[colorIndex] === featuredColor && variant.available) || data.variants.find(variant => String(variant.mediaId) === String(data.featuredMediaId)) || data.variants.find(variant => variant.available) || data.variants[0];
      fields.forEach((field, index) => {
        if (index !== sizeIndex || data.defaultVariant) selectValue(field, index === colorIndex && featuredColor ? featuredColor : featuredVariant.options[index]);
      });
    }
    if (data.defaultVariant) fields.forEach(field => { field.hidden = true; });
    fields.forEach(field => field.addEventListener('change', () => sync()));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.studioShowMedia, true)));
    form.addEventListener('submit', event => {
      if (!currentVariant?.available || !form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
    sync(true);
    section.querySelector('[data-studio-native-options]').hidden = true;
    section.querySelector('[data-studio-enhanced-options]').hidden = false;
    variantSelect.required = false;
    section.dataset.studioReady = 'true';
  }

  function init(root = document) {
    const products = [...root.querySelectorAll('[data-studio-product]')];
    if (root.matches?.('[data-studio-product]')) products.unshift(root);
    products.forEach(initProduct);
    root.querySelectorAll('[data-studio-quantity]').forEach(control => {
      if (control.dataset.studioReady) return;
      const input = control.querySelector('input');
      control.querySelectorAll('[data-studio-quantity-step]').forEach(button => {
        button.addEventListener('click', () => {
          const step = Number(input.step) || 1;
          const min = Number(input.min) || 0;
          const max = input.max ? Number(input.max) : Infinity;
          const next = (Number(input.value) || min) + Number(button.dataset.studioQuantityStep) * step;
          input.value = String(Math.min(max, Math.max(min, next)));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      control.dataset.studioReady = 'true';
    });
    root.querySelectorAll('[data-studio-cart]').forEach(cart => {
      if (cart.dataset.studioReady) return;
      cart.addEventListener('change', event => {
        if (event.target.name !== 'updates[]') return;
        const status = cart.querySelector('[data-studio-cart-status]');
        if (status) status.textContent = status.dataset.message;
      });
      cart.dataset.studioReady = 'true';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
